import React from 'react'
import { Lazyload, Link } from '~/components'
import * as st from '~/assets/styl/Footer.module.styl'
import Logo from '~/assets/svg/Logo-D-Vert.svg'
import LogoDimas from '~/assets/svg/Logo-Dimas.svg'
import { useLanguage } from '~/hooks'

export default function Footer() {
  const { t } = useLanguage()

  return (
    <footer className={st.core}>
      <div className={st.logos}>
        <Lazyload type="img" src={Logo} width="256" height="56" />
        <Lazyload type="img" src={LogoDimas} width="144" height="140" />
      </div>
      <div className={st.legal}>
        <p>{t('Footer.legal')}</p>
      </div>
      <Link href="https://www.tiki.com.br" external rel="external">
        Tiki
      </Link>
    </footer>
  )
}
